/**
 * Maps between world space (meters, y-down to match gravity) and screen space
 * (CSS pixels). Demos pick a `center` and `scale` that frame their scene.
 */
export class Camera {
	screenW = 0;
	screenH = 0;

	constructor(
		public centerX = 0,
		public centerY = 0,
		/** Pixels per world unit. */
		public scale = 40,
	) {}

	setViewport(w: number, h: number): void {
		this.screenW = w;
		this.screenH = h;
	}

	worldToScreenX(x: number): number {
		return (x - this.centerX) * this.scale + this.screenW / 2;
	}
	worldToScreenY(y: number): number {
		return (y - this.centerY) * this.scale + this.screenH / 2;
	}

	screenToWorldX(sx: number): number {
		return (sx - this.screenW / 2) / this.scale + this.centerX;
	}
	screenToWorldY(sy: number): number {
		return (sy - this.screenH / 2) / this.scale + this.centerY;
	}
}
